"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayerProgram = exports.PlayerProgram = void 0;
const anchor_1 = require("@project-serum/anchor");
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const PlayerInstruction = __importStar(require("../instructions/player"));
const Utils = __importStar(require("../utils"));
const programIds_1 = require("../constants/programIds");
const pda_1 = require("../utils/pda");
const { PDA: { getAtaForMint, getItemActivationMarker, getItemPDA, getMetadata, getPlayerPDA, }, } = Utils;
class PlayerProgram extends sol_kit_1.Program.Program {
    constructor() {
        super();
        this.PROGRAM_ID = programIds_1.PLAYER_ID;
        this.instruction = new PlayerInstruction.Instruction({ program: this });
    }
    async getMetadataUpdateAuthority(mint) {
        const metadata = await this.client.provider.connection.getAccountInfo(await getMetadata(mint));
        const mdObj = mpl_token_metadata_1.Metadata.fromAccountInfo(metadata)[0];
        return mdObj.updateAuthority;
    }
    async createPlayerClass(args, accounts, additionalArgs = {}, options) {
        const { instructions, signers } = await this.instruction.createPlayerClass(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async fetchPlayerClass(mint, index) {
        const playerClass = (await getPlayerPDA(mint, index))[0];
        const playerClassObj = await this.client.account.playerClass.fetch(playerClass);
        return playerClassObj;
    }
    async buildPlayer(args, accounts, additionalArgs, options) {
        const { instructions, signers } = await this.instruction.buildPlayer(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async updatePlayerClass(args, accounts, additionalArgs, options) {
        const { instructions, signers } = await this.instruction.updatePlayerClass(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async updatePlayer(args, accounts, additionalArgs, options) {
        const { instructions, signers } = await this.instruction.updatePlayer(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async drainPlayer(args, accounts, additionalArgs = {}, options) {
        const { instructions, signers } = await this.instruction.drainPlayer(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async drainPlayerClass(args, accounts, additionalArgs = {}, options) {
        const { instructions, signers } = await this.instruction.drainPlayerClass(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async toggleEquipItem(args, accounts, additionalArgs, options) {
        var _a;
        if (!accounts.metadataUpdateAuthority) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        if (!additionalArgs.itemClassIndex) {
            const item = await additionalArgs.itemProgram.client.account.item.fetch((await getItemPDA(args.itemMint, args.itemIndex))[0]);
            additionalArgs.itemClassIndex = item.classIndex;
        }
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.validationProgram)) {
            const itemClass = await additionalArgs.itemProgram.fetchItemClass(args.itemClassMint, additionalArgs.itemClassIndex);
            const usage = args.itemUsage ||
                itemClass.object.itemClassData.config.usages[args.itemUsageIndex];
            if (usage) {
                accounts.validationProgram = (_a = usage === null || usage === void 0 ? void 0 : usage.validation) === null || _a === void 0 ? void 0 : _a.key;
            }
        }
        const { instructions, signers } = await this.instruction.toggleEquipItem(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async resetPlayerStats(args, accounts, additionalArgs, options) {
        if (!accounts.metadataUpdateAuthority) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        const { instructions, signers } = await this.instruction.resetPlayerStats(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async useItem(args, accounts, additionalArgs, options) {
        var _a;
        if (!accounts.metadataUpdateAuthority) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.validationProgram)) {
            const itemClass = await additionalArgs.itemProgram.fetchItemClass(args.itemClassMint, args.itemClassIndex);
            const usage = args.itemUsageIndex
                ? itemClass.object.itemClassData.config.usages[args.itemUsageIndex]
                : null;
            if (usage) {
                accounts.validationProgram = (_a = usage === null || usage === void 0 ? void 0 : usage.validation) === null || _a === void 0 ? void 0 : _a.key;
            }
        }
        const { instructions, signers } = await this.instruction.useItem(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async updateValidForUseIfWarmupPassedOnItem(args, accounts, additionalArgs, options) {
        if (!accounts.metadataUpdateAuthority) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        const { instructions, signers } = await this.instruction.updateValidForUseIfWarmupPassedOnItem(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async addItem(args, accounts, additionalArgs, options) {
        if (!accounts.itemMint) {
            throw new Error("Missing itemMint in accounts");
        }
        if (!additionalArgs.itemProgram) {
            throw new Error("Missing itemProgram in additionalArgs");
        }
        if (!accounts.itemAccount) {
            accounts.itemAccount = (await getAtaForMint(accounts.itemMint, this.client.provider.wallet.publicKey))[0];
        }
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.metadataUpdateAuthority)) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        await this.setItemInfoIfNecessary(args, accounts, additionalArgs);
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.validationProgram)) {
            const playerClass = (await this.client.account.playerClass.fetch((await getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0]));
            if (playerClass.data.config.addToPackValidation) {
                accounts.validationProgram =
                    playerClass.data.config.addToPackValidation;
            }
        }
        if (!additionalArgs.totalItemsAvailable) {
            additionalArgs.totalItemsAvailable = new anchor_1.BN((await this.client.provider.connection.getTokenAccountBalance(accounts.itemAccount)).value.uiAmount);
        }
        const { instructions, signers } = await this.instruction.addItem(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async removeItem(args, accounts, additionalArgs, options) {
        if (!accounts.itemMint) {
            throw new Error("Missing itemMint");
        }
        if (!additionalArgs.itemProgram) {
            throw new Error("Missing itemProgram in additionalArgs");
        }
        if (!accounts.itemAccount) {
            accounts.itemAccount = (await getAtaForMint(accounts.itemMint, this.client.provider.wallet.publicKey))[0];
        }
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.metadataUpdateAuthority)) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        await this.setItemInfoIfNecessary(args, accounts, additionalArgs);
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.validationProgram)) {
            const playerClass = (await this.client.account.playerClass.fetch((await getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0]));
            if (playerClass.data.config.addToPackValidation) {
                accounts.validationProgram =
                    playerClass.data.config.addToPackValidation;
            }
        }
        const { instructions, signers } = await this.instruction.removeItem(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async setPlayerClassIndexIfNecessary(playerMint, index, additionalArgs) {
        if (!additionalArgs.classIndex || !additionalArgs.playerClassMint) {
            const player = await this.client.account.player.fetch((await getPlayerPDA(playerMint, index))[0]);
            additionalArgs.classIndex = player.classIndex;
            if (!additionalArgs.playerClassMint) {
                const playerClass = await this.client.account.playerClass.fetch(player.parent);
                if (!playerClass.mint) {
                    throw new Error("Unable to derive player class mint from player class, please pass it in");
                }
                else {
                    additionalArgs.playerClassMint = playerClass.mint;
                }
            }
        }
    }
    async setItemInfoIfNecessary(args, accounts, additionalArgs) {
        if (!additionalArgs.itemClassIndex || !additionalArgs.itemClassMint) {
            const item = await additionalArgs.itemProgram.client.account.item.fetch((await getItemPDA(accounts.itemMint, args.itemIndex))[0]);
            additionalArgs.itemClassIndex = item.classIndex;
            if (!additionalArgs.itemClassMint) {
                const itemClass = await additionalArgs.itemProgram.client.account.itemClass.fetch(item.parent);
                if (!itemClass.mint) {
                    throw new Error("Unable to derive item class mint from item, please pass it in");
                }
                else {
                    additionalArgs.itemClassMint = itemClass.mint;
                }
            }
        }
    }
    async addItemEffect(args, accounts, additionalArgs, options) {
        var _a;
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.metadataUpdateAuthority)) {
            accounts.metadataUpdateAuthority = await this.getMetadataUpdateAuthority(args.playerMint);
        }
        if (!accounts.itemMint) {
            throw new Error("Must pass itemMint!");
        }
        await this.setPlayerClassIndexIfNecessary(args.playerMint, args.index, additionalArgs);
        if (!additionalArgs.amount) {
            const item = (await getItemPDA(accounts.itemMint, args.itemIndex))[0];
            const player = (await getPlayerPDA(args.playerMint, args.index))[0];
            const itemActivationMarkerPDA = (await getItemActivationMarker({
                itemMint: accounts.itemMint,
                itemAccount: (await pda_1.getPlayerItemAccount({ item, player }))[0],
                index: args.itemIndex,
                usageIndex: new anchor_1.BN(args.itemUsageIndex),
                amount: additionalArgs.amount,
            }))[0];
            const itemMarker = await additionalArgs.itemProgram.client.account.itemActivationMarker.fetch(itemActivationMarkerPDA);
            additionalArgs.amount = itemMarker.amount;
        }
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.callbackProgram)) {
            const itemClass = await additionalArgs.itemProgram.fetchItemClass(args.itemClassMint, args.itemClassIndex);
            const usage = itemClass.object.itemClassData.config.usages[args.itemUsageIndex];
            if (usage) {
                accounts.callbackProgram = (_a = usage.callback) === null || _a === void 0 ? void 0 : _a.key;
            }
        }
        const { instructions, signers } = await this.instruction.addItemEffect(args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
    async subtractItemEffect(_args = {}, accounts, additionalArgs, options) {
        if (!accounts.playerClass) {
            const player = await this.client.account.player.fetch(accounts.player);
            accounts.playerClass = player.parent;
        }
        const { instructions, signers } = await this.instruction.subtractItemEffect(_args, accounts, additionalArgs);
        return {
            instructions,
            signers,
            rpc: () => this.sendWithRetry(instructions, signers, options),
        };
    }
}
exports.PlayerProgram = PlayerProgram;
async function getPlayerProgram(anchorWallet, env, customRpcUrl) {
    if (anchorWallet.secretKey) {
        return PlayerProgram.getProgramWithWalletKeyPair(PlayerProgram, anchorWallet, env, customRpcUrl);
    }
    return PlayerProgram.getProgramWithWallet(PlayerProgram, anchorWallet, env, customRpcUrl);
}
exports.getPlayerProgram = getPlayerProgram;
